import { SaleTypeForPlan, SaleTypeForTerm } from "@/lib/gql/__generated__/graphql";

import type { DiscountMultiInputZodSchemaType as InputModel } from "../validation-schema";

/**
 * InputModel の初期値を生成
 * @param hotelID
 * @returns {InputModel}
 */
export const discountMultiInputModelFactory = (hotelID: string): InputModel => {
	return {
		hotelID,
		discountID: "",
		// 基本設定
		// 公開・非公開
		inSale: false,
		// ディスカウントの名前
		name: "",
		// ディスカウントの説明
		description: "",
		// ディスカウントのコード
		discountCode: "",

		// 適用ディスカウント
		multiDiscounts: [],

		// 追加設定
		// キャンセル不可にするか
		isUncancelable: false,
		// 販売タイプ
		saleTypeForPlan: SaleTypeForPlan.Limited,
		// 利用可能期間
		saleTypeForTerm: SaleTypeForTerm.Always,

	} satisfies InputModel;
};
